module.exports = __webpack_public_path__ + "img/Lina.5f7b579e.png";